import {useEffect,useState} from 'react';
import {usePlayerSession} from '@platform/client/session';

// Device/browser UI choice only. The authenticated opaque player ID separates
// people sharing a browser; no token, profile or server preference is stored.
export function useGuidePreference(){
 const session=usePlayerSession(),key='tombalax120.guide.v1.'+(session?.id??'visitor');
 const read=()=>{try{return localStorage.getItem(key)==='hidden';}catch{return false;}};
 const [hidden,setHidden]=useState(read),[error,setError]=useState(false);
 useEffect(()=>{setHidden(read());const changed=(event:StorageEvent)=>{if(event.key===key||event.key===null)setHidden(read());};window.addEventListener('storage',changed);return()=>window.removeEventListener('storage',changed);},[key]);
 const save=(value:boolean)=>{try{if(value)localStorage.setItem(key,'hidden');else localStorage.removeItem(key);setHidden(value);setError(false);}catch{setError(true);}};
 return {hidden,save,error};
}
